import { render, staticRenderFns } from "./ImageCaptureItem.vue?vue&type=template&id=05dd92a0&scoped=true&"
import script from "./ImageCaptureItem.vue?vue&type=script&lang=js&"
export * from "./ImageCaptureItem.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=05dd92a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dd92a0",
  null
  
)

export default component.exports